import { action, runInAction, makeObservable } from "mobx";
import CategoriaApi from "../api/CategoriaApi";
import { CategoriaMinuta, Minuta, Processo } from "../modelo";
import { MovimentoGEDTO } from "../modelo/MinutaMovimentos";
import UsuarioStore from '../store/UsuarioStore';
import CategoriasStore from "../store/CategoriasStore";
import MensagemStore from "../store/MensagemStore";
import MovimentoCNJStore from "../store/MovimentoCNJStore";
import MovimentoService from "./MovimentoService";

class CategoriaService {
    carregarCategorias = async (_processo: Processo = undefined) => {
        runInAction(() => {
            CategoriasStore.carregandoCategorias = true;
        });
        try {
            const categorias = await this.buscarPorOrgaoJulgador(UsuarioStore.gabinete);
            categorias.map(cat => {
                if (!cat.movimentoCNJ) {
                    cat.movimentoCNJ = []
                }
            })
            runInAction(() => {
                if (!CategoriasStore.categorias || CategoriasStore.categorias.length === 0) {
                    CategoriasStore.categorias = categorias;
                }
            });
            return categorias;
        } finally {
            runInAction(() => {
                CategoriasStore.carregandoCategorias = false;
            });
        }
    }

    carregarMovimentoCategoria = async (categoria: CategoriaMinuta, processo?: Processo): Promise<MovimentoGEDTO[]> => {
        if (categoria?.codigoMovimentoCnj) {
            const movimentoCNJ = await MovimentoService.recuperar(categoria.codigoMovimentoCnj);
            if (movimentoCNJ && processo) {
                this.carregarComplementos(movimentoCNJ, processo);
            }
            return [movimentoCNJ];
        }
        return [];
    }

    carregarComplementos = (movimento: MovimentoGEDTO, processo: Processo) => {

        const movimentoCNJ = MovimentoCNJStore.movimentos.find(movCnj => movCnj.codMovimentoCnj === movimento.codMovimentoCnj);
        if (movimentoCNJ?.variaveis.length > 0) {
            MovimentoService.recuperarOpcoesEComplementos(processo, movimento).then(() => {
                MovimentoService.ajustarComplementos(movimento, movimentoCNJ);
            });
        }
    }

    carregarMovimento = (categoria: CategoriaMinuta, processo: Processo, movimentos: MovimentoGEDTO[]) => {
        const indexMov = movimentos.findIndex((movimento) => movimento.codMovimentoCnj === categoria.codigoMovimentoCnj && movimento.variaveis.length > 0);
        if (indexMov >= 0) {
            runInAction(() => {
                categoria.movimentoCNJ[0] = movimentos.splice(indexMov, 1)[0];
                this.carregarComplementos(categoria.movimentoCNJ[0], processo);
            });
        }
        return categoria;
    }

    carregarCategoriasDaMinutaMovimentosComplementos = async (processo: Processo, minuta: Minuta): Promise<CategoriaMinuta[]> => {
        const tipoMinuta = minuta.tipo.codigo;
        const categoriasMinuta = await this.buscarPorMinuta(processo, tipoMinuta);

        return categoriasMinuta;
    };

    constructor() {
        makeObservable(this, {
            carregarCategoriasDaMinutaMovimentosComplementos: action
        });
    }

    async salvar(categoria) {
        return await CategoriaApi.salvar(categoria);
    }

    async buscarPorOrgaoJulgador(orgaoJulgador: string) {
        const categorias = await CategoriaApi.buscarPorOrgaoJulgador(orgaoJulgador);
        return categorias;
    }

    async buscarPorMinuta(processo: Processo, idTipoMinuta): Promise<CategoriaMinuta[]> {
        const categorias = await CategoriaApi.buscarPorMinuta(processo.identificadorProcesso, idTipoMinuta);

        return new Promise((resolve, _reject) => {
            Promise.all(categorias.map(async (categoria) => {
                if (categoria.movimentoCNJ?.length) {
                    const movimentoCNJ = MovimentoCNJStore.movimentos.find(movCNJ => movCNJ.codMovimentoCnj === categoria.codigoMovimentoCnj);
                    await MovimentoService.recuperarOpcoesEComplementos(processo, movimentoCNJ);
                    categoria.movimentoCNJ = categoria.movimentoCNJ.map(movimento => {
                        movimento.complementosPossiveis = movimentoCNJ.complementosPossiveis;
                        movimento.descricaoMovimento = movimentoCNJ.descricaoMovimento;
                        movimento.tipoMovimento = movimentoCNJ.tipoMovimento;
                        const mov = MovimentoGEDTO.novo(movimento);
                        mov.complementos = mov.complementos.map(comp => {
                            const complementoPossivel = movimentoCNJ.complementosPossiveis.find(compPoss => compPoss.codElementoDominio === comp.codElementoDominio);
                            comp.stringComplemento = complementoPossivel?.stringComplemento
                            comp.valorSetado = comp.valorComplemento;
                            return comp;
                        });
                        return mov;
                    });
                }
                return categoria;
            })).then(
                resultCategorias => {
                    resolve(resultCategorias);
                }
            );

        });

    }

    async excluir(numeroCategoria) {
        const result = await CategoriaApi.excluir(numeroCategoria);
        MensagemStore.apresentarMensagem('Categoria excluída com sucesso');
        return result;
    }
}

export default new CategoriaService();
